import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { setLocalKey } from "../../utils/commonfunction";
import { ROLE } from "../../utils/Constants";

const AppLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [errorMessage, setErrorMessage] = useState("");

  const code = searchParams.get("c") || searchParams.get("code");

  useEffect(() => {
    if (!code) {
      setStatus("error");
      setErrorMessage("No login code provided in the URL.");
      return;
    }

    const verifyCode = async () => {
      try {
        const apiBase =
          process.env.REACT_APP_API_URL || "http://localhost:6500/webservice/api/v1";

        const res = await axios.get(
          `${apiBase}/app/booking/verify-web-login-code?c=${encodeURIComponent(code)}`
        );

        if (res.data && (res.data.success || res.data.status)) {
          const data = res.data.data || {};
          const role = data.role;
          const astrologer = data.astrologer;
          const user = data.user;
          const redirectPath = data.path;

          if (role === "astrologer" && astrologer) {
            // Store astrologer session
            const psychicKey = ROLE.PSYCHIC || "psychic";
            setLocalKey(psychicKey, JSON.stringify(astrologer));
            localStorage.setItem("psychic", JSON.stringify(astrologer));
            if (astrologer.token) {
              localStorage.setItem("psychic_token", astrologer.token);
            }
          } else if (role === "user" && user) {
            // Store user session
            const userKey = ROLE.USER || "user";
            setLocalKey(userKey, JSON.stringify(user));
            localStorage.setItem("user", JSON.stringify(user));
            if (user.token) {
              localStorage.setItem("user_token", user.token);
            }
          }

          setStatus("success");
        } else {
          setStatus("error");
          setErrorMessage(res.data?.message || "Invalid or expired login code.");
        }
      } catch (err) {
        console.error("Web login verification failed:", err);
        setStatus("error");
        setErrorMessage(
          err.response?.data?.message ||
            err.message ||
            "Failed to verify login code. Please try requesting a new link from the app."
        );
      }
    };

    verifyCode();
  }, [code]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)",
        fontFamily: "'Segoe UI', Roboto, sans-serif",
        color: "#ffffff",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.07)",
          backdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.15)",
          borderRadius: "20px",
          padding: "40px 30px",
          maxWidth: "460px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)",
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <div
            style={{
              width: "64px",
              height: "64px",
              margin: "0 auto 16px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #6366f1, #a855f7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
            }}
          >
            🔮
          </div>
          <h2 style={{ margin: "0 0 8px", fontSize: "24px", fontWeight: "700" }}>
            Astromitra Web Access
          </h2>
          <p style={{ margin: 0, color: "#94a3b8", fontSize: "14px" }}>
            Web Login Authorization
          </p>
        </div>

        {status === "loading" && (
          <div style={{ padding: "20px 0" }}>
            <div
              className="spinner-border text-light"
              role="status"
              style={{ width: "3rem", height: "3rem", marginBottom: "16px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p style={{ color: "#cbd5e1", fontSize: "15px", margin: 0 }}>
              Verifying login link... Please wait.
            </p>
          </div>
        )}

        {status === "success" && (
          <div style={{ padding: "20px 0" }}>
            <div
              style={{
                fontSize: "48px",
                color: "#22c55e",
                marginBottom: "12px",
              }}
            >
              ✓
            </div>
            <h4 style={{ margin: "0 0 8px", color: "#4ade80", fontSize: "20px", fontWeight: "600" }}>
              Authentication Successful!
            </h4>
            <p style={{ color: "#94a3b8", fontSize: "14px", margin: 0 }}>
              Your session has been authenticated successfully.
            </p>
          </div>
        )}

        {status === "error" && (
          <div style={{ padding: "10px 0" }}>
            <div
              style={{
                fontSize: "48px",
                color: "#ef4444",
                marginBottom: "12px",
              }}
            >
              ⚠️
            </div>
            <h4 style={{ margin: "0 0 10px", color: "#f87171" }}>
              Login Link Error
            </h4>
            <p
              style={{
                color: "#cbd5e1",
                fontSize: "14px",
                lineHeight: "1.5",
                marginBottom: "24px",
                background: "rgba(239, 68, 68, 0.1)",
                border: "1px solid rgba(239, 68, 68, 0.2)",
                padding: "12px",
                borderRadius: "10px",
              }}
            >
              {errorMessage}
            </p>
            <button
              onClick={() => navigate("/")}
              style={{
                background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                color: "#ffffff",
                border: "none",
                padding: "12px 28px",
                borderRadius: "10px",
                fontWeight: "600",
                fontSize: "15px",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(99, 102, 241, 0.4)",
              }}
            >
              Go to Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppLogin;
